// extracted by mini-css-extract-plugin
export var avatarContainer = "_a4-0";
export var avatarTypingWave = "_a4-i";
export var gray = "_a4-f";
export var green = "_a4-c";
export var icon = "_a4-9";
export var image = "_a4-1";
export var lg = "_a4-6";
export var md = "_a4-5";
export var presenceDot = "_a4-b";
export var red = "_a4-d";
export var sm = "_a4-4";
export var status = "_a4-a";
export var typingDot = "_a4-h";
export var typingPill = "_a4-g";
export var xl = "_a4-7";
export var xs = "_a4-3";
export var xxl = "_a4-8";
export var xxs = "_a4-2";
export var yellow = "_a4-e";